import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "../Home/Home";
import Search from "../Search/Search";
import Disclaimer from "../Disclaimer/Disclaimer";
import About from "../About/About";
import { TopBar } from "../../Components/TopBar/TopBar";
import AppContainer from "../../Components/AppContainer/AppContainer";
import "@aws-amplify/ui-react/styles.css";
import { useAuthenticator } from "@aws-amplify/ui-react";
import Navigation from "../../Components/Navigation/Navigation";
import ProtectedRoute from "../../Components/ProtectedRoute/ProtectedRoute";
import { Login } from "../../Components/Login/Login";
import { Signup } from "../../Components/Signup/Signup";
import { useState } from "react";
import Thankyou from "../Thankyou/Thankyou";
import OrgDatasetPage from "../OrgDataset/OrgDatasetPage";
import InvitationAcceptance from "../InvitationAcceptance/InvitationAcceptance";
import Screening from "../Screening/Screening";
import ScheduledJobsPage from "../ScheduledJobsPage/ScheduledJobsPage";
import Enterprise from "../Enterprise/Enterprise";
import EnterpriseDetail from "../Enterprise/EnterpriseDetail";
import LiteratureReviewTools from "../LiteratureReviewTools/LiteratureReviewTools";
import PaperSources from "../PaperSources/PaperSources";
import HelpAndFaq from "../HelpAndFaq/HelpAndFaq";
import Faq from "../Faq/Faq";
import Privacy from "../Privacy/Privacy";
import Settings from "../Settings/Settings";
import Checkout from "../Checkout/Checkout";
import Reports from "../Reports/Reports";

function App() {
  const { user } = useAuthenticator((context) => [context.user]);
  const [isLoginView, setIsLoginView] = useState(true);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [email, setEmail] = useState("");

  const authContent = (
    <div className="auth-container">
      {showOtpInput ? (
        <Signup
          switchToLogin={() => setIsLoginView(true)}
          setShowOtpInput={setShowOtpInput}
          showOtpInput={showOtpInput}
          email={email}
          setEmail={setEmail}
        />
      ) : isLoginView ? (
        <Login
          switchToSignup={() => setIsLoginView(false)}
          setShowOtpInput={setShowOtpInput}
          showOtpInput={showOtpInput}
          setEmail={setEmail}
        />
      ) : (
        <Signup
          switchToLogin={() => setIsLoginView(true)}
          setShowOtpInput={setShowOtpInput}
          showOtpInput={showOtpInput}
          email={email}
          setEmail={setEmail}
        />
      )}
    </div>
  );

  const appContent = (
    <AppContainer>
      <TopBar />
      <Routes>
        <Route path="/login" element={authContent} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/about" element={<About />} />
        <Route path="/help" element={<HelpAndFaq />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/search/:id"
          element={
            <ProtectedRoute>
              <Search />
            </ProtectedRoute>
          }
        />
        <Route
          path="/thankyou"
          element={
            <ProtectedRoute>
              <Thankyou />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/organization-dataset"
          element={
            <ProtectedRoute>
              <OrgDatasetPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/screening"
          element={
            <ProtectedRoute>
              <LiteratureReviewTools />
            </ProtectedRoute>
          }
        />
        <Route
          path="/screening/:id"
          element={
            <ProtectedRoute>
              <LiteratureReviewTools />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/scheduled-runs"
          element={
            <ProtectedRoute>
              <ScheduledJobsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/enterprise"
          element={
            <ProtectedRoute>
              <Enterprise />
            </ProtectedRoute>
          }
        />
        <Route
          path="/enterprise/:enterpriseId"
          element={
            <ProtectedRoute>
              <EnterpriseDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route path="/invitation" element={<InvitationAcceptance />} />
        <Route path="/checkout" element={<Checkout />} />
      </Routes>
    </AppContainer>
  );

  return (
    <Router>
      <Navigation>{appContent}</Navigation>
    </Router>
  );
}

export default App;
